import { checkHql, coveredEquipment, type HomeDocument, type HqlCatalog } from '@rock/hql';
import type { ConsiderationType, EquipmentId, TaskType } from '@rock/types';
import { considerationCadence } from '@rock/util';

/**
 * The units a consideration offered by hand records: for a one-time action, every unit its approved
 * query matches in the home now (even ones an earlier action recorded), so evaluation doesn't suggest
 * them again. Nothing for a recurring reminder, which covers whatever its query matches, or for an
 * action matching no unit.
 */
export function offeredCoverage(input: {
    type: Pick<ConsiderationType, 'appliesTo' | 'spaceId'>;
    taskTypes: TaskType[];
    doc: HomeDocument;
    catalog: HqlCatalog;
    now: Date;
}): EquipmentId[] | undefined {
    const { type, taskTypes, doc, catalog, now } = input;
    if (considerationCadence(taskTypes) !== 'one-time' || !type.appliesTo) return undefined;
    const { compiled } = checkHql(type.appliesTo, catalog, { spaceId: type.spaceId });
    const matched = compiled ? coveredEquipment(compiled, doc, now) : [];
    return matched.length > 0 ? matched : undefined;
}
